import styled from "styled-components";

export const Div = styled.div`
  position: absolute;
  inset: 0;
  pointer-events: none;
  opacity: 0.9;
  filter: blur(0px);
  display: flex;
  align-items: center;
  justify-content: center;

  .BgAnimation__svg {
    width: min(680px, 92vw);
    height: auto;
    max-height: 640px;
    opacity: 0.85;
    filter: drop-shadow(0 18px 70px rgba(35, 234, 235, 0.14));
  }
`;
